import { MeResponseSchema } from "@storytell/types";
import { z } from "zod";

export const GetMeResponseSchema = MeResponseSchema;

export const UpdateMeNameInputSchema = z.object({ name: z.string().min(1) });

export const UpdateMeNameResponseSchema = z.object({ name: z.string() });

export const UpdateMeLocaleInputSchema = z.object({ timezone: z.string(), locale: z.string() });
